import React from 'react';
import { useLanguage } from '../context/LanguageContext';
export const LanguageToggle = () => {
  const {
    language,
    setLanguage
  } = useLanguage();
  return <div className="fixed top-4 right-4 z-50 bg-white/80 backdrop-blur-md p-1 rounded-full shadow-soft border border-border/50 flex items-center gap-1" data-id="element-18">
      <button onClick={() => setLanguage('sv')} aria-label="Byt till svenska" className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${language === 'sv' ? 'bg-terracotta text-white' : 'text-espresso-light hover:bg-cream-dark'}`} data-id="element-19">
        SV
      </button>
      <button onClick={() => setLanguage('en')} aria-label="Switch to English" className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${language === 'en' ? 'bg-terracotta text-white' : 'text-espresso-light hover:bg-cream-dark'}`} data-id="element-20">
        EN
      </button>
    </div>;
};